import {
  onChangeParameter as onChangeParameterOriginal,
  onQuoteRequest
} from 'pu-redux/actions/QuoteActions';

export const onChangeParameter = (name, value) => (dispatch, getState) => {
  const token = document.getElementsByName('authenticity_token')[0].value;
  const variant = document.getElementsByName('variant_id')[0].value;

  onChangeParameterOriginal(name, value)(dispatch);
  const parameters = getState().get('parameters');
  const parametersChanged = getState().get('parametersChanged');

  if (parametersChanged && vfIsValidForQuoteSilent(null, false)) {
    onQuoteRequest(parameters, token, variant, parameters.get('product_quote_number'))(dispatch);
  }
};
